'use strict';

angular.module(ModuleName).directive('fusionUploadFileDirective', [
  '$http',
  function($http){
  var defaultTemplateUrl = '__submodules/fusion-frontend-common/directives/fusion-upload-file/template/default.html';
  var erroMessage = {
    fileNotSupported: 'Sorry, your file is not supported. Please try again.',
    serverFailReponse: 'Sorry, the upload process failed. Please try again.'
  };
  var selectYourFileId = '#fusion-select-your-file';
  var loadingBarId = '#fusion-loading-bar';
  var selectedFileId = '#fusion-selected-file';
  return {
    restrict: 'E',
    scope: {uploadDirective:'=params', uploadPage:'@', messageButton:'@'},
    templateUrl: function(elem, $attrs){
      return $attrs.templateUrl || defaultTemplateUrl;
    },
    link: function($scope, $element, $attrs){
      $scope.formAction = $attrs.formAction;
      $scope.extensionsNotSupported = $attrs.extensionsNotSupported;
      $scope.extensionsSupported = $attrs.extensionsSupported;
      $scope.isImportSection = $scope.uploadPage === 'import';
      $scope.isMyFilesSection = $scope.uploadPage === 'myfiles';

      if($scope.uploadDirective === undefined){
        $scope.uploadDirective = {
          onSuccess: function(){},
          onError: function(){},
          dragAndDropFile: null
        };
      }

      $scope.uploadDirective.dragAndDropFile = $attrs.dragAndDropFile;

      $scope.gotToSelectYourFileUI = function(){
        $('#fusion-file-upload').val('');
        $element.find(selectYourFileId).show();
        $element.find(loadingBarId).hide();
        $element.find(selectedFileId).hide();
        $scope.errorMessage = '';
      };

      $scope.gotToSelectedFileUI = function(){
        if($scope.isImportSection){
          $element.find(selectYourFileId).hide();
          $element.find(selectedFileId).show();
        }
        if($scope.isMyFilesSection){
          $scope.uploadFile();
        }
      };

      $scope.goToLoadingBarUI = function(){
        $element.find(selectedFileId).hide();
        $element.find(loadingBarId).show();
      };

      $scope.getFileExtension = function(){
        if(!$scope.uploadDirective.filename.match(/\./)){
          return ;
        }
        return $scope.uploadDirective.filename.split('.').pop().toLowerCase();
      };

      $scope.isFileExtensionSupported = function(){
        if($scope.extensionsSupported === undefined && $scope.extensionsNotSupported === undefined){
          return true;
        }
        $scope.uploadDirective.extension = $scope.getFileExtension();
        if($scope.extensionsSupported !== undefined){
          return $scope.checkExtensions($scope.extensionsSupported);
        }
        if($scope.extensionsNotSupported !== undefined){
          return $scope.checkExtensions($scope.extensionsNotSupported) ? false : true;
        }
      };

      $scope.checkExtensions = function(arr){
        var extensions = arr.split(',');
        for(var i = 0; i < extensions.length; i++){
          if(extensions[i] === $scope.uploadDirective.extension){
            return true;
          }
        }
        return false;
      };

      $scope.getFilesSupportedDialogFilter = function(){
        if($scope.extensionsSupported !== undefined){
          var extensions = $scope.extensionsSupported.split(',');
          var dialogFilter = '';
          for(var i = 0; i < extensions.length; i++){
            dialogFilter += '.' + extensions[i] + ',';
          }
          $scope.uploadDialogFileFilter = dialogFilter.substring(0, dialogFilter.length - 1);
        }
      };

      $scope.cleanInputFilename = function(){
        document.getElementById('fusion-file-upload').value = '';
      };

      $scope.fileSelectedByUser = function(files){
        var filename = files[0].name;
        if(!filename) {
          return;
        }
        $scope.uploadDirective.filename = filename;
        if($scope.isFileExtensionSupported()){
          $scope.gotToSelectedFileUI();
        }
        else{
          $scope.errorMessage = erroMessage.fileNotSupported;
          $scope.uploadDirective.filename = '';
          $scope.cleanInputFilename();
        }
        $scope.$apply();
        if($scope.isMyFilesSection){
          setTimeout(function(){
            $scope.errorMessage = '';
            $scope.$apply();
          }, 7000);
        }
      };

      $scope.RemoveFile = function(){
        $scope.uploadDirective.filename = '';
        $scope.gotToSelectYourFileUI();
      };

      $scope.uploadFile = function(){
        $scope.goToLoadingBarUI();
        var formData = new FormData();
        formData.append('token', $scope.uploadDirective.token);
        formData.append('type', $scope.isMyFilesSection ? 'USER' : '');
        if($scope.wasDragged){
          formData.append('file', $scope.file);
        }
        else{
          var file = $element.find('input[type=file]');
          formData.append('file', file[0].files[0]);
        }
        $http.post($scope.formAction, formData, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        })
        .success(function(data){
          $scope.uploadDirective.onSuccess(data);
        })
        .error(function(){
          $scope.gotToSelectYourFileUI();
          $scope.errorMessage = erroMessage.serverFailReponse;
          $scope.uploadDirective.onError();
        });
        $scope.cleanInputFilename();
      };

      /* istanbul ignore next */
      $scope.addJSDefaultEvents = function(){
        if($scope.uploadDirective.dragAndDropFile === 'true'){
          $(document).on('dragover', '#file-drop', function(event){
            $('.file-drop').css({'background': '#fcfc94'});
            event.stopPropagation();
            event.preventDefault();
            event.originalEvent.dataTransfer.dropEffect = 'copy';
          });
          $(document).on('drop', '#file-drop', function(event){
            event.stopPropagation();
            event.preventDefault();
            var files = event.originalEvent.dataTransfer.files;
            $scope.uploadDirective.filename = files[0].name;
            if($scope.isFileExtensionSupported()){
              $('.file-drop').css({'background': '#fbfed0'});
              $scope.gotToSelectedFileUI();
              $scope.file = files[0];
              $scope.wasDragged = true;
              $scope.$apply();
            }
            else{
              $('.file-drop').css({'background': '#fcfc94'});
              $scope.uploadDirective.filename = '';
              $scope.errorMessage = erroMessage.fileNotSupported;
            }
          });
          $(document).on('dragleave', '#file-drop', function(){
            $('.file-drop').css({'background': '#fbfed0'});
          });
        }
      };
      $scope.addJSDefaultEvents();
      $scope.gotToSelectYourFileUI();
      $scope.getFilesSupportedDialogFilter();
    }
  };
}
]);
